import { runAction } from "./client";

import { Vehicle } from "../models/Vehicle";
import { assertValue } from "../app/utils/assert";

export interface VehiclesGeopositionRequest
{
    Vehicle: (string|number)[];
}

export interface VehiclesGeopositionResult
{
    Vehicle: VehicleGeoposition[];
    Gapik: string;
}

export interface VehicleGeoposition extends Vehicle
{
    Geoposition: Geoposition[];
}

export interface Geoposition
{
    Latitude: number;
    Longitude: number;
    DateTime: string;
    DateTimeUtc: string;
}

export interface GetVehiclesGeopositionFn
{
    (request: VehiclesGeopositionRequest): Promise<VehiclesGeopositionResult>;
}

export const getVehiclesGeoposition: GetVehiclesGeopositionFn = (request: VehiclesGeopositionRequest) => {
    assertValue(request);
    return runAction<VehiclesGeopositionResult>('/action/GetVehiclesGeoposition', request);
};


// WEBPACK FOOTER //
// ./src/rest/GetVehiclesGeoposition.ts